import React from 'react'

const Footer = () => {
  return (
    <div className='footer-copyright'>
      <p>@2022 Travel Bucket List. All rights reserved.</p>
    </div>
  )
}

export default Footer
